import { render, staticRenderFns } from "./Livedata.vue?vue&type=template&id=47f21ac4&"
import script from "./Livedata.vue?vue&type=script&lang=js&"
export * from "./Livedata.vue?vue&type=script&lang=js&"
import style0 from "./Livedata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports